import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  toolbar: theme.mixins.toolbar,
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  tabBar: {
    height: "initial"
  },
  menuButton: {
    marginLeft: -theme.spacing(1)
  },
  link: {
    textDecoration: "none",
    color: theme.palette.secondary.main,
    "&:hover": {
      color: theme.palette.secondary.light
    }
  },
  button: {
    borderColor: theme.palette.secondary.main
  },
  title: {
    alignItems: "center",
    display: "flex",
    marginLeft: -theme.spacing(2)
  }
}));
